import $ from 'jquery';
import objectFitImages from 'object-fit-images';

$(() => {
    const ratioImages = $('div[class*="ratio-"] img');
    objectFitImages(ratioImages);
});
